import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { ICommendaProductTaxCode } from './types';

export function useSalesTaxProductTaxCodesByCorporationId({
  token,
  filters,
}: {
  token: string;
  filters: {
    corporationId: number;
  };
}) {
  const {
    data,
    mutate,
    error,
  }: {
    data: {
      data: {
        taxCodes: ICommendaProductTaxCode[];
      };
    };
    error?: unknown;
    mutate?: KeyedMutator<unknown>;
  } = useSWR(
    `new-sales-tax/products/taxCodes/corporation/${filters.corporationId}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data: data?.data?.taxCodes,
    mutate,
    error,
  };
}
